import {
  CellApiModule,
  CellSelectionModule,
  CellStyleModule,
  ClipboardModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnHoverModule,
  ColumnMenuModule,
  ContextMenuModule,
  CustomEditorModule,
  CustomFilterModule,
  DateFilterModule,
  EventApiModule,
  GridStateModule,
  LocaleModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  PinnedRowModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowGroupingModule,
  RowStyleModule,
  ScrollApiModule,
  SelectEditorModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SetFilterModule,
  TextEditorModule,
  TextFilterModule,
  TooltipModule,
  ValidationModule,
} from 'ag-grid-enterprise';
/**
 * More info in https://www.ag-grid.com/javascript-data-grid/modules/
 */
export const registerModules = () => {
  ModuleRegistry.registerModules([
    ColumnAutoSizeModule,
    ColumnHoverModule,
    PinnedRowModule,
    RowAutoHeightModule,
    RowStyleModule,
    RowDragModule,
    RowGroupingModule,
    CellStyleModule,
    TextFilterModule,
    NumberFilterModule,
    DateFilterModule,
    CustomFilterModule,
    TextEditorModule,
    SelectEditorModule,
    NumberEditorModule,
    CustomEditorModule,
    GridStateModule,
    ColumnApiModule,
    RowApiModule,
    CellApiModule,
    RenderApiModule,
    EventApiModule,
    SetFilterModule,
    CellSelectionModule,
    ColumnMenuModule,
    ContextMenuModule,
    ClipboardModule,
    ServerSideRowModelApiModule,
    ServerSideRowModelModule,
    TooltipModule,
    ScrollApiModule,
    LocaleModule,
  ]);
  if (import.meta.env.DEV) {
    ModuleRegistry.registerModules([ValidationModule]);
  }
};
